export default "__VITE_ASSET__HbbkgnXs__"